import * as React from 'react';

const currentYear = new Date().getFullYear();
const years = [];
for (let year = 2020; year <= currentYear; year++) {
  years.push(year);
}

export function InvoiceMonthSelector({
  selectedYear,
  selectedMonth,
  setSelectedMonth,
  setSelectedYear,
}) {
  return (
    <>
      <div className="col-sm">
        <label htmlFor="invoiceYearSelect">Year</label>
        <select
          className="form-control"
          id="invoiceYearSelect"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div className="col-sm">
        <label htmlFor="invoiceMonthSelect">Month</label>
        <select
          className="form-control"
          id="invoiceMonthSelect"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
        >
          <option value="1">Januar</option>
          <option value="2">Februar</option>
          <option value="3">März</option>
          <option value="4">April</option>
          <option value="5">Mai</option>
          <option value="6">Juni</option>
          <option value="7">Juli</option>
          <option value="8">August</option>
          <option value="9">September</option>
          <option value="10">Oktober</option>
          <option value="11">November</option>
          <option value="12">Dezember</option>
        </select>
      </div>
    </>
  );
}
